import Feature from 'ol/Feature.js';
import Map from 'ol/Map.js';
import Overlay from 'ol/Overlay.js';
import Point from 'ol/geom/Point.js';
import TileJSON from 'ol/source/TileJSON.js';
import GeoJSON from 'ol/format/GeoJSON';
import VectorSource from 'ol/source/Vector.js';
import View from 'ol/View.js';
import {Icon, Style, Stroke, Fill} from 'ol/style.js';
import {Tile as TileLayer, Vector as VectorLayer, Image as ImageLayer} from 'ol/layer.js';
import {fromLonLat,toLonLat} from 'ol/proj';
import OSM from 'ol/source/OSM.js';
import ImageWMS from 'ol/source/ImageWMS.js';


const nLLonLat = [5, 52];
const nLLonLatWebMercator = fromLonLat(nLLonLat);

const osm = new TileLayer({
  title: 'osm',
  type: 'base',
  visible: true,
  source: new OSM()
});



const style_darkgreen = new Style({
  fill: new Fill({color: 'rgba(0, 100, 0, 1.0)',}),
  stroke: new Stroke({color: 'rgba(0, 0, 0, 1.0)',})
});
const style_green = new Style({
  fill: new Fill({color: 'rgba(0, 255, 0, 1.0)',}),
  stroke: new Stroke({color: 'rgba(0, 0, 0, 1.0)',})
});
const style_yellow = new Style({
  fill: new Fill({
   color: 'rgba(255, 255, 0, 1.0)',
 }),
 stroke: new Stroke({color: 'rgba(0, 0, 0, 1.0)',})
});
const style_orange = new Style({
  fill: new Fill({
   color: 'rgba(255, 165, 0, 1.0)',
 }),
 stroke: new Stroke({color: 'rgba(0, 0, 0, 1.0)',})
});
const style_red = new Style({
  fill: new Fill({
   color: 'rgba(255, 0, 0, 1.0)',
 }),
 stroke: new Stroke({color: 'rgba(0, 0, 0, 1.0)',})
});
const style_darkred = new Style({
  fill: new Fill({
   color: 'rgba(139, 0, 0, 1.0)',
 }),
 stroke: new Stroke({color: 'rgba(0, 0, 0, 1.0)',})
});


const getStyle = function(feature) {
 // alert(feature.get("gm_naam"));
    if (feature.get("eenper") == 0) {return style_darkred;}
    else 
    {
      if (feature.get("eenper") < 7500) {return style_darkgreen;}
      else 
      {
        if (feature.get("eenper") < 10000) {return style_green;}
        else 
        {
          if (feature.get("eenper") < 15000) {return style_yellow;}
          else 
          {
            if (feature.get("eenper") < 25000) {return style_orange;}
          else 
            {
              return style_red;
            } 
          } 
        }
      }
    }
}
 
const chineesfromjson = new VectorLayer({
  title: 'Restaurant',
  source: new VectorSource({
    url: 'https://geoserver.mijnlieff.nl/geoserver/dechinees/ows?service=WFS&version=1.0&request=GetFeature&typeName=dechinees:restaurantspergemeente&outputFormat=application/json',
    format: new GeoJSON(),
  }),
  style: function (feature) {return getStyle(feature);},
});



const map = new Map({
  layers: [osm,  chineesfromjson],
  target: document.getElementById('map'),
  view: new View({
    center: nLLonLatWebMercator,
    zoom: 8,
  }),
});

const element = document.getElementById('popup');

const popup = new Overlay({
  element: element,
  positioning: 'bottom-center',
  stopEvent: false,
});
map.addOverlay(popup);

let popover;
function disposePopover() {
  if (popover) {
    popover.dispose();
    popover = undefined;
  }
}
// display popup on click
map.on('click', function (evt) {
  const feature = map.forEachFeatureAtPixel(evt.pixel, function (feature) {
    return feature;
  });
  disposePopover();
  if (!feature) {
    return;
  }
  popup.setPosition(evt.coordinate);
  popover = new bootstrap.Popover(element, {
    placement: 'top',
    html: true,
    content: function () {
        var returnval = 'Gemeente ' + feature.get('gm_naam')+'<br>';
        returnval += feature.get('aantal')+' Restaurants<br>';
        if (feature.get('eenper') == 0)
          {returnval += 'Geen restaurants in deze gemeente<br>'}
        else {
           returnval += 'Een restaurant per ' + feature.get('eenper') + ' inwoners<br>'
        }
        
        return returnval;
    }
  });
  popover.show();
});

// Close the popup when the map is moved
map.on('movestart', disposePopover);
